//const baseDomain = "http://localhost:3333";
//const baseDomain = "https://staging.x0pa.ai";
const baseDomain = `${window.location.protocol}//${window.location.host}`;
const baseUrl = `${baseDomain}/roboroy/api/v1`;
export { baseUrl };
